import { getRequest, postRequest } from 'src/services/requests';
import { SobreDTO } from '../types/dtos/genericos';

const buscarAplicacoesWeb = (
  security?: boolean
): Promise<{
  success: boolean;
  hash: string;
  messages: string[];
  data: {
    Aplicacoes: [
      {
        Portal: string;
        NomeExibicao: string;
        Nome: string;
        Endereco: string;
        Security: boolean;
        PossuiDireito: boolean;
      }
    ];
  };
}> => {
  return new Promise((resolve, reject) => {
    postRequest(
      `/genericos/ge/ambiente/BuscarAplicacoesWeb?somenteEnderecos=false&security=${
        security || false
      }`,
      '',
      resolve,
      reject
    );
  });
};

const verificarConectividade = (
  url: string,
  allowRedirect: boolean
): Promise<{
  success: boolean;
  messages: string[];
  data: { IsAvailable: boolean };
  tipoLogin: string;
}> => {
  return new Promise((resolve, reject) => {
    getRequest(
      `/genericos/ge/ambiente/VerificarConectividade?url=${url}&allowRedirect=${allowRedirect}`,
      resolve,
      reject
    );
  });
};

const buscarDadosSobre = (): Promise<SobreDTO> => {
  return new Promise((resolve, reject) => {
    postRequest(`/genericos/ge/ambiente/Sobre`, null, resolve, reject);
  });
};
export { buscarAplicacoesWeb, verificarConectividade, buscarDadosSobre };
